export const actionTypes = {
  RESULTS_STATE_CLEANUP: 'RESULTS_STATE_CLEANUP',
  RESULTS_UPDATE: 'RESULTS_UPDATE',
  RESULTS_LOADING_FRESH_RESULTS: 'RESULTS_LOADING_FRESH_RESULTS',
  RESULTS_LOADING_FRESH_RESULTS_DONE: 'RESULTS_LOADING_FRESH_RESULTS_DONE',
  RESULTS_UPDATING_PAGE: 'RESULTS_UPDATING_PAGE',
  RESULTS_UPDATING_PAGE_DONE: 'RESULTS_UPDATING_PAGE_DONE',
  RESULTS_UPDATING_PAGE_LIMIT: 'RESULTS_UPDATING_PAGE_LIMIT',
  RESULTS_UPDATING_PAGE_LIMIT_DONE: 'RESULTS_UPDATING_PAGE_LIMIT_DONE',
  RESULTS_EMIT_ERROR: 'RESULTS_EMIT_ERROR',
  RESULTS_LOADING: 'RESULTS_LOADING',
};
